import gql from "graphql-tag";

export const CREATE_TEMPORAL_PATIENT = gql`
  mutation createPatientForCheckIn($data: AffiliateWhereInput) {
    createPatientForCheckIn(data: $data)
  }
`;
